<template>
    <div class="unified-filter-row" @click.stop>
        <e-input
            :placeholder="placeholder"
            :model-value="modelValue"
            class="filter-content-text"
            expanded
            @input="handleInput"
        />
    </div>
</template>

<script>
export default {
    name: 'TextFilterItem',

    props: {
        filter: {
            type: Object,
            required: true,
        },
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: 'Enter text...',
        },
        applyFilter: {
            type: Function,
            required: true,
        },
    },

    methods: {
        handleInput(event) {
            this.applyFilter(this.filter, event.target.value, event);
        },
    },
};
</script>
